import { TextField } from "../../../atoms/Form";
import { type ConstructedTextField } from "../types";

export const FIELD_NAME_ROOM_NAME = "roomName";

const tLabel = "Room Name";
const tRequired = "Room name is required";
const tLengthMax = "Room name cannot exceed 200 characters";
const tLengthMin = "Room name must be at least 2 characters";

export type RoomNameProps = ConstructedTextField & { required?: boolean };

export const RoomName = ({ required = true, textFieldProps, ...props }: RoomNameProps) => {
  return (
    <TextField
      name={FIELD_NAME_ROOM_NAME}
      textFieldProps={{
        inputProps: { maxLength: 200, minLength: 2 },
        label: tLabel,
        required,
        ...textFieldProps,
      }}
      validate={(value, _, meta) => {
        if (required && meta?.modified && !value) {
          return tRequired;
        }

        if (meta?.dirty && value) {
          if (value.length < 2) {
            return tLengthMin;
          }

          if (value.length > 200) {
            return tLengthMax;
          }
        }

        return "";
      }}
      {...props}
    />
  );
};
